import Repository from './Repository'

export default {

  urlDownloadTemplate () {
    return Repository.baseURL() + 'dashboard/users/bulk-template'
  },
  uploadTemplate (file) {
    const formData = new FormData()
    formData.append('csv_file', file)

    return Repository.multipart().post(
      'dashboard/users/bulk-file', formData
    )
  },
  confirmUpload (id, params) {
    return Repository.private().patch(
      'dashboard/users/bulk-file/' + id, params
    )
  }

}
